exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-cloud__tag__jxy8M{margin-right:4px;margin-bottom:4px}", ""]);

// exports
exports.locals = {
	"tag": "tags-cloud__tag__jxy8M"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/tags-cloud/tags-cloud.styl
// module id = 1868
// module chunks = 1 2